import { lazy } from 'react';
import type { RouteConfig } from '../types';
import { ComponentSuspense } from '@/components/ui/suspense-wrapper';

const DeploymentsListPage = lazy(
    () => import('@/pages/app/admin/deployments/list')
);

const CreateDeploymentPage = lazy(
    () => import('@/pages/app/admin/deployments/create')
);

const DeploymentDetailPage = lazy(
    () => import('@/pages/app/admin/deployments/[id]')
);

export const deploymentRoutes: RouteConfig[] = [
    {
        path: 'admin/deployments',
        element: (
            <ComponentSuspense>
                <DeploymentsListPage />
            </ComponentSuspense>
        ),
        meta: {
            title: 'Deployments | UzaForm',
            description: 'View and manage all deployments',
        },
    },
    {
        path: 'admin/deployments/create',
        element: (
            <ComponentSuspense>
                <CreateDeploymentPage />
            </ComponentSuspense>
        ),
        meta: {
            title: 'Create Deployment | UzaForm',
            description: 'Create a new deployment',
        },
    },
    {
        path: 'admin/deployments/:id',
        element: (
            <ComponentSuspense>
                <DeploymentDetailPage />
            </ComponentSuspense>
        ),
        meta: {
            title: 'Edit Deployment | UzaForm',
            description: 'Edit deployment details',
        },
    },
];
